module.exports = __webpack_public_path__ + "img/settings2.93e5361f.png";